import Vue from 'vue';
import vant from 'vant';

// 所有vant组件
import { Button } from 'vant';
import { NavBar } from 'vant';
import { Search } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Field } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Switch } from 'vant';
import { Icon } from 'vant';
import { Popup } from 'vant';
import { Tab, Tabs } from 'vant';
import { TreeSelect } from 'vant';
import { List,pullRefresh } from 'vant';
import { DatetimePicker } from 'vant';
import { Toast } from 'vant';
import { Empty  } from 'vant';
import { Dialog } from 'vant';
import { Overlay } from 'vant';
import { CountDown } from 'vant';
import { Calendar } from 'vant';
import { Divider } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Form } from 'vant';
import { Stepper } from 'vant';
import { Picker } from 'vant';
import { Circle } from 'vant';
import { ImagePreview } from 'vant';
import { Uploader } from 'vant';
import { ActionSheet } from 'vant';
import { Cascader } from 'vant';
import { Sticky } from 'vant';
import { Swipe, SwipeItem } from 'vant';
// 全局注册
Vue.use(Cascader);
Vue.use(Uploader);
Vue.use(ImagePreview);
Vue.use(Circle);
Vue.use(Picker);
Vue.use(Stepper);
Vue.use(Form);
Vue.use(Calendar);
Vue.use(CountDown);
// 全局注册
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(TreeSelect);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(NavBar)
Vue.use(Button)
Vue.use(Search)
Vue.use(List)
Vue.use(pullRefresh)
Vue.use(DatetimePicker)
Vue.use(Empty)
Vue.use(Overlay)
Vue.use(Divider);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(ActionSheet);
Vue.use(Sticky);
Vue.use(Swipe);
Vue.use(SwipeItem);


// WEBPACK FOOTER //
// ./src/plugins/vant.js